module.exports = __webpack_public_path__ + "static/img/blanket.3db997d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/prints/blanket.jpg
// module id = mUk0
// module chunks = 1